import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Relationship = (props) => {

  const { endrelationship } = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const history = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (data) => {
    const request = {};
    request.mentee_id = endrelationship.mentee_id;
    request.mentor_id = endrelationship.mentor_id;
    request.actionid = endrelationship.actionid;

    request.reason = data.reason;
    request.user_role = "Mentor";

    setIsSubmitting(true);

    agent
      .post(API.LOAD_CUSTOMER + "/updateReason", request)
      .then((res) => {
        if (props.refreshList) {
          props.refreshList();
        }
        setPopupMessage(res?.data?.message || "Request completed successfully.");
        setShowPopup(true);
      })
      .catch((err) => {
        const errorMessage = err?.res?.data?.message || "Something went wrong. Please try again.";
        setPopupMessage(errorMessage);
        setShowPopup(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton>Reason*</Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <Form.Control
                  as="textarea"
                  className={
                    errors.reason ? "form-control is-invalid" : "form-control"
                  }
                  name="reason"
                  defaultValue={endrelationship.mentor_reason}
                  aria-invalid={errors.reason ? "true" : "false"}
                  {...register("reason", {
                    required: {
                      value: true,
                      message: "Please enter reason",
                    },
                    validate: (value) => {
                      if (value.trim() == "") {
                        return "Please enter reason";
                      } else {
                        return true;
                      }
                    }
                  })}
                />
                {errors?.reason?.message && (
                  <label className="customeValidationText text-left">
                    {errors?.reason?.message}
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <button
                    className="btn loginsubmit nextbtn ml-2"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
          props.onHide();      // close parent modal
          history("/dashboard"); // navigate after user clicks OK
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Relationship.propTypes = {
  endrelationship: PropTypes.shape({
    mentee_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mentor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.number,
    actionid: PropTypes.number,
    reason: PropTypes.string,
    mentor_reason: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  refreshList: PropTypes.func,
};

export default Relationship;
